// node_modules
import axios from "axios";
import { LoggingConstants } from "Constants";
import { ToastTypeEnum } from "Enums";
// Helpers
import { AxiosHelperSingleton, PendoHelperSingleton, ToastHelperSingleton } from "Helpers";
import { TTechnologyImageDTO, TTechnologyYoutubeVideoDTO } from "Types";

export class MediaController {

    public async AddLocalImageToTechnology(technologyId: number, selectedFile: File, caption: string): Promise<TTechnologyImageDTO> {
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}MediaAddLocalImage`, {
            technologyId: technologyId
        });
        
        const formData = new FormData();
        formData.append("caption", caption);
        formData.append("files", selectedFile);
        const result = await axios.post<TTechnologyImageDTO>(`${AxiosHelperSingleton.getServerBaseURL()}api/media/localimage/technology/${technologyId}`,
            formData, { headers: { "Content-Type": "multipart/form-data" } });
        return result.data;
    }

    public async AddImageUrlToTechnology(technologyId: number, imageUrl: string, caption: string): Promise<TTechnologyImageDTO> {
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}MediaAddUrlImage`, {
            technologyId: technologyId
        });
       
        const formData = new FormData();
        formData.append("caption", caption);
        formData.append("imageUrl", imageUrl);
        const result = await axios.post<TTechnologyImageDTO>(`${AxiosHelperSingleton.getServerBaseURL()}api/media/urlimage/technology/${technologyId}`,
            formData, { headers: { "Content-Type": "multipart/form-data" } });
        return result.data;
    }

    public async AddYoutubeVideoToTechnology(technologyId: number, youtubeUrl: string, caption: string): Promise<TTechnologyYoutubeVideoDTO> {
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}MediaAddYoutubeVideo`, {
            technologyId: technologyId
        });
        
        const formData = new FormData();
        formData.append("caption", caption);
        formData.append("youtubeUrl", youtubeUrl);
        const result = await axios.post<TTechnologyYoutubeVideoDTO>(`${AxiosHelperSingleton.getServerBaseURL()}api/media/youtubevideo/technology/${technologyId}`,
            formData, { headers: { "Content-Type": "multipart/form-data" } });
        return result.data;
    }

    public async DownloadImageUrl(imageUrl: string): Promise<Blob | null> {
        // Gather information about the selected image
        const headResponse = await axios.head(imageUrl);
        if (headResponse.status !== 200) {
            ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Could not download the selected image.");
            return null;
        }
        // Check if the image is too large, if so do nothing
        if (parseInt(headResponse.headers["content-length"]) >= 2000000) {
            ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Selected image has a too big filesize. (bigger than 2MB)");
            return null;
        }

        // Check if the image has a valid content-type
        let contentType;
        if ("content-type" in headResponse.headers) {
            contentType = headResponse.headers["content-type"];
        } else {
            ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Could not determine the image type.");
            return null;
        }

        // Download the image to an arraybuffer
        const downloadImageResponse = await axios.get(imageUrl, { responseType: "arraybuffer" });
        if (downloadImageResponse.status !== 200) {
            console.log("Could not download the selected image.");
            return null;
        }

        // Return the downloaded image as a blob
        return new Blob([downloadImageResponse.data], { type: contentType });
    }
}

export const MediaControllerSingleton = new MediaController();